import React, { useEffect, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { AccordionProps } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import DetailsHistory, { IDetailsHistoryProps } from '../detailsHistory/detailsHistory';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';
import { SpinnerLoading } from '@/main/components/shared/styles';
import * as S from './styles';
import { ProcurementHistoricalRequest } from '@/main/models/request';
import { procurementHistoricalapi } from '@/main/api';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { isNullUndefined } from '@/main/services/utils';

export type IFetchMoreRequest<T = any> = T & {
  pageIndex?: number | undefined;
};
export interface IFetchMoreResponse {
  data: any[];
  totalNumberOfRecords: number;
}
interface IAcordeonHistoryProps {
  title: string;
  showPrices?: boolean;
  guidProcurement: string;
  propsCollapse?: Omit<AccordionProps, 'children'>;
}

function AccordionHistory({
  title,
  showPrices = true,
  propsCollapse = {},
  guidProcurement,
}: IAcordeonHistoryProps) {
  const [hasShowMore, setHasShowMore] = React.useState(false);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);

  const [
    formFilters,
    setFormFiltersOrderHistory
  ] = useState<ProcurementHistoricalRequest | null>(null);

  const [ dataHistory, setDataHistory] = useState<
    IDetailsHistoryProps[]
  >([]);

  async function getDataOrderHistory() {
    const request = {
      guidProcurement: guidProcurement,
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize20
    } as ProcurementHistoricalRequest;

    setFormFiltersOrderHistory(request);
  }

  // Initial load
  useEffect(() => {
    getDataOrderHistory();
  }, []);

  async function fetchMore(
    request: IFetchMoreRequest<ProcurementHistoricalRequest>
  ) {
    return procurementHistoricalapi.getHeader(request).then(response => {
      const { results, totalNumberOfRecords } = response.data;
      const formatteDataOrder: IDetailsHistoryProps[] = results.map(item => ({
        id: item.guidProcurementHistorical,
        guidProcurementHistorical: item.guidProcurementHistorical,
        date: item.date,
        hours: item.time,
        title: item.action,
        userName: item.username,
        idAction: item.idAction,
        showPrices
      }));
      return {
        data: formatteDataOrder,
        totalNumberOfRecords
      };
    });
  }

  async function onLoadInfiniteScroll() {
    const nextIndex = pageIndex + 1;
    if(isNullUndefined(formFilters)) return;
    const mountRequest = {
      ...formFilters,
      pageIndex: nextIndex
    };
    setPageIndex(nextIndex);

    await fetchMore(mountRequest).then(dataFetch => {
      const { data, totalNumberOfRecords } = dataFetch;
      const newDataHistory = [...dataHistory, ...data];
      setDataHistory(newDataHistory);
      setHasShowMore(totalNumberOfRecords > newDataHistory.length);
    });
  }

  useEffect(() => {
    if (formFilters === null) return;
    setIsLoading(true);
    onLoadInfiniteScroll().finally(() => setIsLoading(false));
  }, [formFilters]);

  return (
    <S.AccordionHistoryStyle {...propsCollapse}>
      <S.AccordionSummaryHistory
        id={`id-modalHistory-accordion-history-${title}`}
        aria-controls="categories-content"
        expandIcon={<ExpandMore fontSize="medium" />}>
        <S.AccordionTitle>{title}</S.AccordionTitle>
      </S.AccordionSummaryHistory>
      <S.AccordionDetailsHistory id={`id-scrollable-target-history-${title}`}>
        <InfiniteScroll
          scrollableTarget={`id-scrollable-target-history-${title}`}
          hasMore={hasShowMore}
          dataLength={dataHistory.length}
          next={onLoadInfiniteScroll}
          loader={<SpinnerLoading />}>
          {isLoading ? (
            <SpinnerLoading />
          ) : dataHistory.length === 0 ? (
            <ResultNotFoundComponent />
          ) : (
            <S.ContentHistory>
              {dataHistory.map(item => (
                <DetailsHistory
                  key={item.id}
                  guidProcurementHistorical={item.guidProcurementHistorical}
                  title={item.title}
                  date={item.date}
                  hours={item.hours}
                  userName={item.userName}
                  showPrices={showPrices}
                  idAction={item.idAction}
                />
              ))}
            </S.ContentHistory>
          )}
        </InfiniteScroll>
      </S.AccordionDetailsHistory>
    </S.AccordionHistoryStyle>
  );
}

export default AccordionHistory;
